import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CTA } from '../components/CTA';
import { TrustBadge } from '../components/TrustBadge';
import { ShieldIcon, TruckIcon, CreditCardIcon, LockIcon } from 'lucide-react';
export const Checkout = () => {
  return <div className="bg-white min-h-screen w-full" data-id="element-278">
      <Header data-id="element-279" />
      <main className="max-w-4xl mx-auto px-4 py-6" data-id="element-280">
        <div className="mb-8 text-center" data-id="element-281">
          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-282">
            Rond Je Bestelling Af
          </h1>
          <p className="text-gray-600" data-id="element-283">
            Je bent nog maar één stap verwijderd van gezonder, mooier haar
          </p>
        </div>
        {/* Order Summary */}
        <section className="mb-8" data-id="element-284">
          <div className="bg-gray-50 rounded-lg p-6" data-id="element-285">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-286">
              Bestellingsoverzicht
            </h2>
            <div className="flex mb-4" data-id="element-287">
              <div className="w-20 h-20 rounded-md overflow-hidden flex-shrink-0" data-id="element-288">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cAF7SQASUrZNHAiiQeQ3FA/13_pdp-hero-jar_1000x1000.jpg" alt="QISS Moleculair Herstel Haarmasker" className="w-full h-full object-cover" data-id="element-289" />
              </div>
              <div className="ml-4 flex-grow" data-id="element-290">
                <h3 className="font-bold text-gray-900" data-id="element-291">
                  QISS Moleculair Herstel Haarmasker
                </h3>
                <p className="text-sm text-gray-600" data-id="element-292">
                  8 oz / 240ml pot - 8-10 behandelingen
                </p>
                <div className="mt-1 flex justify-between" data-id="element-293">
                  <span className="text-gray-700" data-id="element-294">Aantal: 1</span>
                  <span className="font-medium" data-id="element-295">€79,95</span>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-4 mb-4" data-id="element-296">
              <div className="flex justify-between mb-2" data-id="element-297">
                <span data-id="element-298">Subtotaal</span>
                <span data-id="element-299">€79,95</span>
              </div>
              <div className="flex justify-between mb-2 text-green-600" data-id="element-300">
                <span data-id="element-301">Verzending</span>
                <span data-id="element-302">GRATIS</span>
              </div>
              <div className="flex justify-between font-bold text-lg" data-id="element-303">
                <span data-id="element-304">Totaal</span>
                <span data-id="element-305">€79,95</span>
              </div>
            </div>
            <div className="bg-green-50 p-3 rounded text-sm text-green-800" data-id="element-306">
              <p data-id="element-307">
                <strong data-id="element-308">Speciale Aanbieding:</strong> Bestel vandaag en ontvang
                een GRATIS Zijden Haarwrap (t.w.v. €29,95)
              </p>
            </div>
          </div>
        </section>
        {/* Trust Badges */}
        <section className="mb-8" data-id="element-309">
          <div className="grid grid-cols-4 gap-2" data-id="element-310">
            <TrustBadge icon={<ShieldIcon className="w-8 h-8" data-id="element-312" />} text="60-Dagen Geld-Terug Garantie" data-id="element-311" />
            <TrustBadge icon={<TruckIcon className="w-8 h-8" data-id="element-314" />} text="Gratis Verzending" data-id="element-313" />
            <TrustBadge icon={<CreditCardIcon className="w-8 h-8" data-id="element-316" />} text="Veilige Betaling" data-id="element-315" />
            <TrustBadge icon={<LockIcon className="w-8 h-8" data-id="element-318" />} text="Privacy Beschermd" data-id="element-317" />
          </div>
        </section>
        {/* Guarantee */}
        <section className="mb-8" data-id="element-319">
          <div className="border border-gray-200 rounded-lg p-4 flex" data-id="element-320">
            <div className="mr-4" data-id="element-321">
              <ShieldIcon className="w-12 h-12 text-pink-600" data-id="element-322" />
            </div>
            <div data-id="element-323">
              <h3 className="font-bold text-gray-900 mb-1" data-id="element-324">
                Onze 60-Dagen Tevredenheidsgarantie
              </h3>
              <p className="text-sm text-gray-700" data-id="element-325">
                Als je niet volledig tevreden bent met je QISS Moleculair
                Herstel Haarmasker om welke reden dan ook, stuur het dan binnen
                60 dagen terug voor een volledige terugbetaling van je
                aankoopbedrag. Geen vragen gesteld, geen gedoe.
              </p>
            </div>
          </div>
        </section>
        {/* Testimonial Snippet */}
        <section className="mb-8" data-id="element-326">
          <div className="bg-pink-50 p-4 rounded-lg" data-id="element-327">
            <p className="italic text-gray-700 mb-2" data-id="element-328">
              "Ik heb duizenden euro's uitgegeven aan salonbehandelingen die
              niet de helft van de resultaten leverden die ik met QISS heb
              gezien. Mijn haar is getransformeerd!"
            </p>
            <div className="flex justify-end" data-id="element-329">
              <p className="text-sm font-medium text-pink-800" data-id="element-330">
                — Margriet, 58
              </p>
            </div>
          </div>
        </section>
        {/* Final CTA */}
        <section className="mb-8 text-center" data-id="element-331">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-332">
            Rond Je Aankoop Af
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-333">
            Klik hieronder om je bestelling veilig af te ronden en begin je
            haartransformatiereis
          </p>
          <CTA text="Ga Naar Veilige Afrekening" destination="https://checkout.example.com" className="max-w-md mx-auto" eventName="Purchase" eventParams={{
          content_type: 'product',
          content_ids: ['QISS-hair-mask'],
          currency: 'EUR',
          value: 79.95,
          num_items: 1
        }} data-id="element-334" />
          <p className="mt-2 text-sm text-gray-600" data-id="element-335">
            Door je bestelling te plaatsen, ga je akkoord met onze Algemene
            Voorwaarden en Privacybeleid
          </p>
        </section>
      </main>
      <Footer data-id="element-336" />
    </div>;
};